import constants from '../constants';
import actionTypes from '../constants/action-types';

const siteName = (state = null, action) => {
  switch (action.type) {
    case actionTypes.RELOAD_SITE_META:
    case actionTypes.CONNECT_SITE:
      return action.payload.site.name || constants.DEFAULT_SITE_NAME;
    case actionTypes.SET_SITE_NAME:
      return action.payload.siteName;
    default:
      return state;
  }
};

export default siteName;
